const numberFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const numberUtils = {
  asPercent(value: number) {
    return `${Math.round(value)}%`;
  },
  asCurrency(value: number) {
    return numberFormat.format(value);
  },
  asCurrencyWithDefault(value: number, defaultValue = '-') {
    return value ? this.asCurrency(value) : defaultValue;
  },
  prettyPrintNumber(int: number | string) {
    const parts = int.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },
};
